
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources02Off as ObiSources02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-02-off.js';
 
 
 

 
 export const ObiSources02Off = createComponent({
   react: React,
   tagName: 'obi-sources-02-off',
   elementClass: ObiSources02OffElement,
   events: {
     
   }
  });
 
 